/** Seções da tela Fiscal → Configurações fiscais (os nomes citados nas mensagens e na ajuda). */
export type Section = "provedor" | "operacoes" | "regras_uf" | "series" | "pagamentos" | "perfis";

export const FISCAL_CONFIG_SECTIONS: { key: Section; label: string }[] = [
  { key: "provedor", label: "Dados fiscais e provedor" },
  { key: "operacoes", label: "Operações e usos" },
  { key: "regras_uf", label: "Regras por UF" },
  { key: "series", label: "Séries" },
  { key: "pagamentos", label: "Pagamentos eletrônicos" },
  { key: "perfis", label: "Perfis e grupos tributários" },
];
